/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DoseTimingResponse } from './DoseTimingResponse';
import {
    DoseTimingResponseFromJSON,
    DoseTimingResponseFromJSONTyped,
    DoseTimingResponseToJSON,
    DoseTimingResponseToJSONTyped,
} from './DoseTimingResponse';
import type { PatientCommonExpression } from './PatientCommonExpression';
import {
    PatientCommonExpressionFromJSON,
    PatientCommonExpressionFromJSONTyped,
    PatientCommonExpressionToJSON,
    PatientCommonExpressionToJSONTyped,
} from './PatientCommonExpression';
import type { ConceptGroupResponseCurrentEntryStatus } from './ConceptGroupResponseCurrentEntryStatus';
import {
    ConceptGroupResponseCurrentEntryStatusFromJSON,
    ConceptGroupResponseCurrentEntryStatusFromJSONTyped,
    ConceptGroupResponseCurrentEntryStatusToJSON,
    ConceptGroupResponseCurrentEntryStatusToJSONTyped,
} from './ConceptGroupResponseCurrentEntryStatus';

/**
 * 
 * @export
 * @interface ConceptGroupResponse
 */
export interface ConceptGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof ConceptGroupResponse
     */
    conceptGroupId?: number;
    /**
     * 
     * @type {string}
     * @memberof ConceptGroupResponse
     */
    pharmacyPrescriptionType?: string;
    /**
     * 
     * @type {number}
     * @memberof ConceptGroupResponse
     */
    customPrescriptionDays?: number;
    /**
     * 
     * @type {string}
     * @memberof ConceptGroupResponse
     */
    pharmacyInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof ConceptGroupResponse
     */
    patientInfo?: string;
    /**
     * 
     * @type {number}
     * @memberof ConceptGroupResponse
     */
    definingSapExpressionId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConceptGroupResponse
     */
    isSapDeletable?: boolean;
    /**
     * 
     * @type {Array<PatientCommonExpression>}
     * @memberof ConceptGroupResponse
     */
    conceptExpressions?: Array<PatientCommonExpression>;
    /**
     * 
     * @type {Array<DoseTimingResponse>}
     * @memberof ConceptGroupResponse
     */
    doseTimings?: Array<DoseTimingResponse>;
    /**
     * 
     * @type {ConceptGroupResponseCurrentEntryStatus}
     * @memberof ConceptGroupResponse
     */
    currentEntryStatus?: ConceptGroupResponseCurrentEntryStatus;
    /**
     * 
     * @type {PatientCommonExpression}
     * @memberof ConceptGroupResponse
     */
    definingSapExpression?: PatientCommonExpression;
}

/**
 * Check if a given object implements the ConceptGroupResponse interface.
 */
export function instanceOfConceptGroupResponse(value: object): value is ConceptGroupResponse {
    return true;
}

export function ConceptGroupResponseFromJSON(json: any): ConceptGroupResponse {
    return ConceptGroupResponseFromJSONTyped(json, false);
}

export function ConceptGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConceptGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'conceptGroupId': json['conceptGroupId'] == null ? undefined : json['conceptGroupId'],
        'pharmacyPrescriptionType': json['pharmacyPrescriptionType'] == null ? undefined : json['pharmacyPrescriptionType'],
        'customPrescriptionDays': json['customPrescriptionDays'] == null ? undefined : json['customPrescriptionDays'],
        'pharmacyInfo': json['pharmacyInfo'] == null ? undefined : json['pharmacyInfo'],
        'patientInfo': json['patientInfo'] == null ? undefined : json['patientInfo'],
        'definingSapExpressionId': json['definingSapExpressionId'] == null ? undefined : json['definingSapExpressionId'],
        'isSapDeletable': json['isSapDeletable'] == null ? undefined : json['isSapDeletable'],
        'conceptExpressions': json['conceptExpressions'] == null ? undefined : ((json['conceptExpressions'] as Array<any>).map(PatientCommonExpressionFromJSON)),
        'doseTimings': json['doseTimings'] == null ? undefined : ((json['doseTimings'] as Array<any>).map(DoseTimingResponseFromJSON)),
        'currentEntryStatus': json['currentEntryStatus'] == null ? undefined : ConceptGroupResponseCurrentEntryStatusFromJSON(json['currentEntryStatus']),
        'definingSapExpression': json['definingSapExpression'] == null ? undefined : PatientCommonExpressionFromJSON(json['definingSapExpression']),
    };
}

export function ConceptGroupResponseToJSON(json: any): ConceptGroupResponse {
    return ConceptGroupResponseToJSONTyped(json, false);
}

export function ConceptGroupResponseToJSONTyped(value?: ConceptGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conceptGroupId': value['conceptGroupId'],
        'pharmacyPrescriptionType': value['pharmacyPrescriptionType'],
        'customPrescriptionDays': value['customPrescriptionDays'],
        'pharmacyInfo': value['pharmacyInfo'],
        'patientInfo': value['patientInfo'],
        'definingSapExpressionId': value['definingSapExpressionId'],
        'isSapDeletable': value['isSapDeletable'],
        'conceptExpressions': value['conceptExpressions'] == null ? undefined : ((value['conceptExpressions'] as Array<any>).map(PatientCommonExpressionToJSON)),
        'doseTimings': value['doseTimings'] == null ? undefined : ((value['doseTimings'] as Array<any>).map(DoseTimingResponseToJSON)),
        'currentEntryStatus': ConceptGroupResponseCurrentEntryStatusToJSON(value['currentEntryStatus']),
        'definingSapExpression': PatientCommonExpressionToJSON(value['definingSapExpression']),
    };
}

